export default {
  ducky: 'Ducky',
  home: 'Home',
  help: 'Help',
  account: 'Account',
  logout: 'Logout',
  language_menu: 'Language',
  menu: 'Menu',
};
